import React from "react";

const STRENGTH_CONFIG = {
  weak: { color: "bg-red-500", width: "w-1/4", label: "Weak" },
  moderate: { color: "bg-yellow-500", width: "w-2/4", label: "Moderate" },
  strong: { color: "bg-green-500", width: "w-3/4", label: "Strong" },
  "very-strong": {
    color: "bg-green-700",
    width: "w-full",
    label: "Very Strong",
  },
};

const PasswordStrengthBar = ({ strength, valid, details }) => {
  const config = STRENGTH_CONFIG[strength] || STRENGTH_CONFIG.weak;
  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between text-xs">
        <span
          className={
            valid
              ? "text-green-600 dark:text-green-400"
              : "text-gray-500 dark:text-gray-400"
          }
        >
          {config.label}
        </span>
        {valid && (
          <span className="text-green-600 dark:text-green-400">
            Meets requirements
          </span>
        )}
      </div>
      <div className="h-1.5 w-full bg-gray-200 dark:bg-gray-600 rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all ${config.color} ${config.width}`}
        />
      </div>
      {details && details.length > 0 && (
        <ul className="text-xs text-red-500 dark:text-red-400 list-disc list-inside">
          {details.map((msg, i) => (
            <li key={i}>{msg}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PasswordStrengthBar;
